// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7045":"13326dc58f0fee9a","7898":"d7127e3ddd7de4f5"}[chunkId] + ".css";
};